import { WrappedFieldProps } from 'redux-form';
import * as React from 'react';
import * as styles from './FormSection.css';
import Grid from '@material-ui/core/Grid/Grid';

export interface FormProps {
  type: string;
  disabled?: boolean;
  label: string;
  children?: JSX.Element;
}

const FormSection = (props: WrappedFieldProps & FormProps) => (
  <Grid container justify="center" className={styles.section}>
    <Grid item container>
      {props.label && (
        <Grid item container alignItems="center" xs={6} sm={6}>
          <b>{props.label}:</b>
        </Grid>
      )}

      <Grid item xs={6}>
        {props.children}
      </Grid>
    </Grid>
    <Grid item container justify="center">
      {props.meta.touched && props.meta.error && <span>{props.meta.error}</span>}
    </Grid>
  </Grid>
);

export default FormSection;
